import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../store';
import { IPowerBiEmbedData } from '../../types';
import { getPowerBiEmbedData } from '../../utils/api';

interface IPowerBiEmbedState {
  embedData: IPowerBiEmbedData | null;
  isLoading: boolean;
}

interface IGetEmbedDataParams {
  reportId: string;
  groupId: string;
}

const initialState: IPowerBiEmbedState = {
  embedData: null,
  isLoading: false,
};

export const getEmbedData = createAsyncThunk(
  'powerBiEmbed/getEmbedData',
  async ({ reportId, groupId }: IGetEmbedDataParams) => {
    return await getPowerBiEmbedData(reportId, groupId);
  }
);

export const powerBiEmbedSlice = createSlice({
  name: 'powerBiEmbed',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEmbedData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEmbedData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.embedData = action.payload;
      })
      .addCase(getEmbedData.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const selectPowerBiEmbedState = (state: RootState) =>
  state.powerBiEmbedData;
export default powerBiEmbedSlice.reducer;
